import React from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { DataWell, Col } from "common/components";
import { ModalProvider } from "common/contexts";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import QueryHelper from "components/common/QueryHelper";
import { useGetInvestigationProcedures } from "security-app/hooks/useInvestigationsAPI";
import { listElements } from "./constants";
import { columnRenderers } from "./column-renderers";
import useTableElements from "./use-table-elements";
import Modals from "./Modals";
const Subtitle = styled.span`
  color: ${({ theme }) => theme.colors.text.secondary};
`;
const HUMAN_NAME = "Investigation Procedures";
function Procedures() {
  const { id } = useParams();
  const { getInvestigationProcedures, investigationProceduresQueryKeyFn } = useGetInvestigationProcedures(id);
  const { expandedSections } = useTableElements();
  return /* @__PURE__ */ React.createElement(ModalProvider, null, /* @__PURE__ */ React.createElement(DataWell, { $color: "content", style: { flexGrow: 1 } }, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement("h2", null, "Event Procedures"), /* @__PURE__ */ React.createElement(Subtitle, null, "Merged event procedures from events added to the investigation are presented here, deduplicated and grouped together to enable bulk actions.")), /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: HUMAN_NAME,
      tableLayout: listElements.defaultLayout,
      queryHelpComponent: /* @__PURE__ */ React.createElement(QueryHelper, { entityName: HUMAN_NAME }),
      fetchEntities: getInvestigationProcedures,
      keyFn: investigationProceduresQueryKeyFn,
      entityAttributesAreCamelCase: false,
      columnRenderers,
      expandedSectionRenderers: expandedSections,
      externalSearch: { query: "" },
      withoutURLParams: true,
      noPageSizeSelect: true,
      noColumnReordering: true
    }
  )), /* @__PURE__ */ React.createElement(Modals, null));
}
export default Procedures;
